import React from 'react';
import { Box, Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams } from 'react-router-dom';
import PageLayout from '../../components/common/PageLayout';
import SolarSiteDetail from './SolarSiteDetail';

// Deep-link page for a single site (/manage/solar/:id). The primary UX is the fleet dialog;
// this remains for direct links and browser refresh.
export default function SolarSitePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <PageLayout contentMaxWidth="xl" showHeaderImage={false} showOrgHeader>
      <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <Link component="button" onClick={() => navigate('/manage/solar')} underline="hover"
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mb: 1.5 }}>
          <ArrowBackIcon fontSize="small" /> Back to fleet
        </Link>
        <SolarSiteDetail siteId={id} />
      </Box>
    </PageLayout>
  );
}
